/**
 * Created by mukund on 1/3/18.
 *
 * Service that holds all the JS code for responsiveness
 */

'use strict';

angular.module('mediacloudApp')
    .factory('ResponsivenessService', function ($resource) {

        return {

            makePnPThumbnailsResponsive: function(){
                $('.pnp-item .overlayimage').each(function () {
                    // var width = $(this).width();
                    // if (width && width >= 100) {
                    //     var height = width / 16 * 9;
                    //     if (height) {
                    //         $(this).css('height', height + "px");
                    //     }
                    // }
                    // $(this).css('width', '252px');
                    $(this).css('height', '142px');

                });
            }

        }
    });

